import './Button.css';

const buttonVariants = {
  primary: 'custom-button-primary',
  secondary: 'custom-button-secondary',
};

const Button = ({
  children,
  className = '',
  variant = 'primary',
  type = 'button',
  ...props
}) => {
  return (
    <button
      type={type}
      className={`custom-button ${buttonVariants[variant]} ${className || ''}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
